import { getHomepage as getHomepageOrigin } from "@/lobby_common/api/basic_gen.js";
import { getPersonalCenterTemplate as getPersonalCenterTemplateOrigin } from "@/lobby_common/api/basic_gen.js";
import { getResource as getResourceOrigin } from "@/lobby_common/api/resource_gen.js";
import { Decrypt } from "@/lobby_common/utils/secret.js";
import store from "@/lobby_common/store";
import { getCacheData } from "@/lobby_common/utils/index";
const isProd = process.env.NODE_ENV === "production";

// cdn base地址
// const CACHE_BASE_URL = store.getters.getPacketDomain?.webHotUpdateUrl || '';
const getCacheUrl = () => store.getters?.getPacketDomain?.webHotUpdateUrl || "";
// cdn 接口地址
const getCdnData = () => store.getters?.getPacketDomain?.tpl;

const getLanguage = () => store.getters?.getLang || "en";

function getLanguageUrl(url) {
  try {
    if (!url) return url;
    const lang = getLanguage();
    const urls = url.split("_").reverse();
    if (urls.length > 1) {
      urls.splice(0, 1, `${lang}.json`);
      return urls.reverse().join("_");
    } else {
      return url;
    }
  } catch (error) {
    return url;
  }
}

function useCache() {
  // 是否开启api模式
  const apiMode = window.localStorage.getItem("apiMode") || "";
  if (apiMode === "true") {
    return false;
  }
  return true;
}
// const getKey = (initKey) => {
//   const isLogin = store.getters.taken;
//   if (isLogin) {
//     return initKey + "_isLogin";
//   } else {
//     return initKey + "_noLogin";
//   }
// };

// export const getHomepageC = async (data) => {
//   let key = getKey("homePage");
//   if (data?.sid) {
//     // 副首页
//     key = getKey("viceHomePage");
//   }
//   return await cacheFun(getHomepage, data, key);
// };
// 获取首页模板
// Req : open_proto.client.v1.basic.GetHomepageReq
// Resp: open_proto.client.v1.basic.GetHomepageResp
export const getHomepage = (data) => {
  // const key = getKey("homePage");
  if (data?.sid) {
    return getHomepageOrigin(data);
  } else {
    try {
      const homepage = getCacheData('homepage');
      if (homepage) {
        return {
          code: 0,
          data: homepage,
        }
      }
    } catch (error) {
      return getHomepageOrigin();
    }
    return getHomepageOrigin();
  }
};

const getViceHomePage = (data) => {
  return getHomepageOrigin(data).then(res => {
    if (res.code === 0 && res.data?.homepage) {
      return {
        code: res.code,
        data: res.data.homepage
      }
    }
    return res;
  });
}

export const getHomepagePc = (data) => {
  if (data?.sid) {
    return getViceHomePage(data);
  }
  return getJSON(getCdnData()?.getResourcePc, getHomepageOrigin, data).then(res => {
    console.log('homepage pc', res)
    if (res.code === 0 && res.data?.homepage) {
      return {
        code: res.code,
        data: res.data.homepage
      }
    }
    return res;
  })
};


export const getHomepageH5 = (data) => {
  if (data?.sid) {
    return getViceHomePage(data);
  }
  return getJSON(getCdnData()?.getResourceH5, getHomepageOrigin, data).then(res => {
    console.log('homepage h5', res)
    if (res.code === 0 && res.data?.homepage) {
      return {
        code: res.code,
        data: res.data.homepage
      }
    }
    return res;
  })
};

// 获取资源
// Req : open_proto.client.v1.resource.GetResourceRequest
// Resp: open_proto.client.v1.resource.GetResourceResponse
export const getResource = (data) => getJSON(getCdnData()?.getResource, getResourceOrigin).then(res => {
  if (!res.data?.resource) {
    return {
      code: res.code,
      data: {
        resource: res.data,
      }
    }
  }
  return res;
})
// 获取H5个人中心模版
// Req : open_proto.client.v1.basic.GetPersonalCenterTemplateReq
// Resp: open_proto.client.v1.basic.GetPersonalCenterTemplateResp
export const getPersonalCenterTemplate = (data) => {
  return getJSON(getCdnData()?.getPartTpl, getPersonalCenterTemplateOrigin).then(res => {
    if (res.data?.person && res.data?.version) {
      return {
        code: res.code,
        data: res.data.person
      }
    }
    return res;
  })
}


const callFun = (fun, data) => {
  return fun(data).then(res => {
    return res;
  })
}

// 获取JSON
function getJSON(url, fun, data) {
  url = getLanguageUrl(url);
  if (!url) return callFun(fun, data);
  if (useCache()) {
    return fetch(`${getCacheUrl()}${url}`)
      .then((res) => {
        return res
          .json()
          .then((jsonRes) => {
            const data = {
              code: 0,
              data: null,
            };
            if (isProd) {
              // 解密
              data.data = Decrypt(jsonRes);
            } else {
              data.data = Decrypt(jsonRes);
              console.log("cdn json:", data.data);
              // data.data = JSON.parse(jsonRes);
            }
            return data;
          })
          .catch(() => callFun(fun, data));
      })
      .catch(() => callFun(fun, data));
  }

  return callFun(fun, data);
}
